<template>
  <div class="leco-content">
    <div class="page-title">トレーニングの集計人数</div>
    <div v-show="mainLoading" class="loader">loading...</div>
    <transition>
      <div v-show="!mainLoading" class="content-wrapper">
        <vue-good-table
          :columns="training_info_columns"
          :rows="training_info_rows"
        >
        </vue-good-table>
        <div class="clearfix"></div>

        <div class="page-title page-title2">社員別の受講希望／講師可否</div>
        <p v-if="errorMessege != ''" class="alert alert-danger">
          {{ errorMessege }}
        </p>

        <vue-good-table
          :columns="training_attender_columns"
          :rows="training_attender_rows"
          max-height="73vh"
          :fixed-header="true"
          :search-options="{
            enabled: true
          }"
        >
        </vue-good-table>
      </div>
    </transition>
  </div>
</template>

<script>
//import { mapGetters } from "vuex";
import axios from "axios";
import jQuery from "jquery";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import Vue from "vue";
import { API_BASE_URL } from "@/common/config";
Vue.use(VueGoodTablePlugin);

global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");

export default {
  name: "wish-list-detail",

  data() {
    return {
      training_info_columns: [
        {
          label: "トレーニング名",
          field: "training_name"
        },
        {
          label: "受講者数",
          field: "total_attended"
        },
        {
          label: "受講希望＋絶対参加",
          field: "total_hope_fot_participation"
        },
        {
          label: "講師数",
          field: "total_capable_for_lecturer"
        }
      ],
      training_info_rows: [],
      training_attender_columns: [
        {
          label: "社員名",
          field: "employee_name"
        },
        {
          label: "受講ステータス",
          field: "attended_flag_name"
        },
        {
          label: "希望ステータス",
          field: "want_status_name"
        },
        {
          label: "講師ステータス",
          field: "coach_status_name"
        }
      ],
      training_attender_rows: [],
      errorMessege: "",
      training_name: "",
      mainLoading: false,
      logger: this.$store.state.logger
    };
  },

  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    this.mainLoading = true;
    //希望状況詳細一覧を取得
    this.errorMessege = "";
    let id = this.$route.params.id;
    this.logger.info("希望状況詳細一覧を取得：id=" + id);

    let api_url = API_BASE_URL + "trainings/wish/" + id;
    this.logger.debug(api_url);
    axios
      .get(api_url, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((response) => {
        //statusCode==200以外は全部500のエラー画面に飛ばす
        if ("statusCode" in response.data) {
          if (response.data.statusCode == 200) {
            this.logger.info("希望状況詳細一覧の読み込み終了。");
            this.logger.debug(JSON.stringify(response.data));
            this.training_info_rows.push(response.data.body.training_info);
            this.training_attender_rows = response.data.body.attenders;
            this.training_name = response.data.body.training_info.training_name;
          } else if (response.data.statusCode == 404) {
            this.errorMessage = "希望者はまだいません。";
          } else {
            this.$router.push("/system-error500");
          }
        } else {
          this.$router.push("/system-error500");
        }
        this.mainLoading = false;
      })
      .catch((error) => {
        this.mainLoading = false;
        this.logger.error("希望状況詳細一覧の読み込みに失敗");
        this.logger.error(JSON.stringify(error));
        this.$router.push("/system-error500");
      });
  }
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .content-wrapper {
    margin-right: 10px;
    margin-left: 10px;
  }
}

.page-title2 {
  margin-top: 40px;
}

/* loadingアイコン用CSS */
.loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
